import React from "react";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function showWarningMessage(message, autoreload = false, error = null) {
  toast(
    <>
      <FontAwesomeIcon icon="exclamation-circle" />
      <span className="text">{message}</span>
    </>,
    {
      position: "bottom-right",
      autoClose: 12000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      bodyClassName: "cob-toast-body",
      className: "cob-toast",
      type: "warning",
    }
  );

  if (autoreload && process.env.NODE_ENV === "production") {
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  } else {
    // eslint-disable-next-line
    console.log("ERROR: ", error);
  }
}
